// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function randomIndexInArray(arr: Array<any>): number
{
  if (arr.length === 0)
    return -1;
  return (Math.random() * arr.length) >> 0;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function randomInArray(arr: Array<any>): any | false
{
  if (arr.length === 0)
    return false;
  return arr[randomIndexInArray(arr)];
}